import { OOSIcon } from './oos-icon';

export { OOSIcon };
